import React from "react";
import { useState, useEffect } from "react";
import "./styles.css";

function App() {
  const [todo, setTodo] = React.useState(null);
  const [todo2, setTodo2] = React.useState(null);
  const [todo3, setTodo3] = React.useState({});
  const [todo4, setTodo4] = React.useState({});
  const [id, setId] = React.useState(1);

  React.useEffect(() => {
    if (id == null || id === "") {
      return;
    }

    fetch(`https://pokeapi.co/api/v2/pokemon/${id}`)
      .then((results) => results.json())
      .then((data) => {
        setTodo(data.sprites.front_default);
      });
    fetch(`https://pokeapi.co/api/v2/pokemon/${id}`)
      .then((results) => results.json())
      .then((data) => {
        setTodo2(data.name);
      });
    fetch(`https://pokeapi.co/api/v2/pokemon/${id}`)
      .then((results) => results.json())
      .then((data) => {
        setTodo3(Object.values(data.sprites));
      });
    fetch(`https://pokeapi.co/api/v2/pokemon/${id}`)
      .then((results) => results.json())
      .then((data) => {
        setTodo4(data);
      });
  }, [id]); // useEffect will trigger whenever id is different.

  return (
    <div>
      <h1>Pokemon App created by Fernando</h1>
      <h4> Enter pokemon number or name below to see image</h4>
      <input value={id} onChange={(e) => setId(e.target.value)} />
      <br />
      <p>{JSON.stringify(todo2)}</p>

      <img src={todo} width="200" px height="200" px />
      <img src={todo3[0]} width="200" px height="200" px />
      <img src={todo3[6]} width="200" px height="200" px />

      <pre>{JSON.stringify(todo4, null, 2)}</pre>
    </div>
  );
}

export default App;
